import React from 'react';
import BaseEVerifyUsersReview, { CommonEVerifyUsersReviewProps } from './BaseEVerifyUsersReview';
import { useToggles } from '../../../context/Toggles/TogglesContext';

const EmployerEVerifyUsersReview = ({ users, onEditButtonClick }: CommonEVerifyUsersReviewProps): JSX.Element => {
  const toggles = useToggles();
  const isMfaEnvironment = toggles?.get('MFA_USER_CREATION') === 'on';
  return (
    <BaseEVerifyUsersReview
      sectionText="E-Verify Users"
      editButtonText={isMfaEnvironment ? 'Edit E-Verify Users' : 'Edit Users'}
      showPointOfContact={!isMfaEnvironment}
      mouSignatoryField={{ mouSignatories: users?.filter((user) => user.mouSignatory === 'Yes') }}
      adminField={{
        fieldText: `Program Administrator${isMfaEnvironment ? '' : '(s)'}`,
        admins: users?.filter((user) => user.admin === 'Yes'),
      }}
      onEditButtonClick={onEditButtonClick}
    />
  );
};

export default EmployerEVerifyUsersReview;
